import React, { useContext, useEffect, useState } from 'react';
import { DropArea } from '../../../../../../components/form/DropArea/DropArea';
import { useStore } from '../../../../../../store';
import { UserMessage } from '../../../../../../DesignSystem/LiliUserMessage/UserMessage';
import { BillPreview } from '../BillPreview';
import { MAX_FILE_SIZE_MB } from '../../../AddBill/consts';
import { ACCEPTED_BILL_TYPES } from '../../../../consts';
import { useUploadBillFile } from '../../hooks/useUploadBillFile';
import { CreationCtx } from '../../pages';

export const BillAttachment = () => {
  const [isBillPreview, setIsBillPreview] = useState<boolean>(false);
  const { setBillData, billData } = useStore(state => state);
  const { mutateAsync, isLoading } = useUploadBillFile();
  const context = useContext(CreationCtx);
  const handleFile = async (files: FileList) => {
    const fileToUpload = files[0];
    const billImageUrl = URL.createObjectURL(fileToUpload);
    const formData = new FormData();
    formData.append('document', fileToUpload);
    const { documentId } = await mutateAsync({ payload: formData });
    setBillData({
      ...billData, billImageUrl, assetType: fileToUpload.type, documentId, assetName: fileToUpload.name,
    });
  };

  const handlePreview = () => {
    if (billData.billImageUrl) {
      setIsBillPreview(true);
    }
  };

  const handleClearFile = () => {
    setBillData({
      ...billData, billImageUrl: '', assetType: '', documentId: '',
    });
  };

  useEffect(() => {
    context.setIsLoadingBillAttachment(isLoading);
  }, [isLoading]);

  return (
    <div className='w-full h-fit pt-[32px] border-t border-bw03'>
      {isBillPreview && (
      <UserMessage
        onClick={() => setIsBillPreview(false)}
        contentWrapperClassName='w-[500px] h-full ml-auto animate-slideRightToLeft shadow-light'
        id='billPreviewModal'
      >
        {billData.billImageUrl && <BillPreview onClose={() => setIsBillPreview(false)} />}
      </UserMessage>
      )}
      <DropArea acceptedTypes={ACCEPTED_BILL_TYPES} onFileClear={handleClearFile} onFileClick={handlePreview} isMinimalMode maxFileSizeInMb={MAX_FILE_SIZE_MB} onFilesChange={handleFile} />
    </div>
  );
};
